/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base colors for the Material Dashboard 2 React.
 * You can add new color using this file.
 * You can customized the colors for the entire Material Dashboard 2 React using thie file.
 */

const colors = {
  background: {
    default: "#eef1f6",
    hover: "#fafbfd",
    sidenav: "#12141f",
  },

  text: {
    main: "#6b7180",
    focus: "#6b7180",
    muted: "#989daa",
  },

  sidenav: {
    text: "#a6abc0",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#2f7de1",
    focus: "#1f5fb8",
  },

  secondary: {
    main: "#6b7180",
    focus: "#7c8291",
  },

  info: {
    main: "#2f7de1",
    focus: "#1f5fb8",
  },

  success: {
    main: "#1fa971",
    focus: "#178f5f",
  },

  warning: {
    main: "#e0972a",
    focus: "#c78320",
  },

  error: {
    main: "#e5484d",
    focus: "#c93a3f",
  },

  light: {
    main: "#eef1f6",
    focus: "#e3e6ee",
  },

  dark: {
    main: "#1c2030",
    focus: "#12141f",
  },

  grey: {
    100: "#f8f9fa",
    200: "#eef1f6",
    300: "#e3e6ee",
    400: "#cfd3de",
    500: "#adb5bd",
    600: "#6b7180",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  // Near-solid pairs: "gradient" variants render visually flat in the new design
  gradients: {
    primary: {
      main: "#2f7de1",
      state: "#1f5fb8",
    },

    secondary: {
      main: "#6b7180",
      state: "#565b68",
    },

    info: {
      main: "#2f7de1",
      state: "#1f5fb8",
    },

    success: {
      main: "#1fa971",
      state: "#178f5f",
    },

    warning: {
      main: "#e0972a",
      state: "#c78320",
    },

    error: {
      main: "#e5484d",
      state: "#c93a3f",
    },

    light: {
      main: "#f5f7fb",
      state: "#eef1f6",
    },

    dark: {
      main: "#1a1d2c",
      state: "#12141f",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#e0ecfb",
      text: "#2f7de1",
    },

    secondary: {
      background: "#e9ebf0",
      text: "#6b7180",
    },

    info: {
      background: "#e0ecfb",
      text: "#2f7de1",
    },

    success: {
      background: "#e5f7ee",
      text: "#1fa971",
    },

    warning: {
      background: "#fdf3e2",
      text: "#e0972a",
    },

    error: {
      background: "#fdecec",
      text: "#e5484d",
    },

    light: {
      background: "#ffffff",
      text: "#989daa",
    },

    dark: {
      background: "#e3e6ee",
      text: "#1c2030",
    },
  },

  coloredShadows: {
    primary: "#2f7de1",
    secondary: "#6b7180",
    info: "#2f7de1",
    success: "#1fa971",
    warning: "#e0972a",
    error: "#e5484d",
    light: "#adb5bd",
    dark: "#141623",
  },

  inputBorderColor: "#e3e6ee",

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};

export default colors;
